import { render, staticRenderFns } from "./prospectDepartmentAssign.vue?vue&type=template&id=48436662&scoped=true"
import script from "./prospectDepartmentAssign.vue?vue&type=script&lang=js"
export * from "./prospectDepartmentAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48436662",
  null
  
)

export default component.exports